import {
  connect,
  Contract,
  keyStores,
  WalletConnection,
} from "near-api-js";

/*const nearConfig = {
  networkId: "testnet",
  nodeUrl: "https://rpc.testnet.near.org",
  contractName: "ft_test_20221014.testnet",
  walletUrl: "https://wallet.testnet.near.org",
  helperUrl: "https://helper.testnet.near.org",
  explorerUrl: "https://explorer.testnet.near.org",
  keyStore: new keyStores.BrowserLocalStorageKeyStore(),
};*/

// Uncomment for production
const nearConfig = {
  networkId: 'mainnet',
  nodeUrl: 'https://rpc.mainnet.near.org',
  contractName: "token.stlb.near",
  walletUrl: 'https://wallet.near.org',
  helperUrl: 'https://helper.mainnet.near.org',
  explorerUrl: "https://explorer.mainnet.near.org",
  keyStore: new keyStores.BrowserLocalStorageKeyStore(),
};

let walletConnection = null;

const formatTokensToFiveDecimalPlaces = unformattedNumberOfTokens => {
    if(unformattedNumberOfTokens <= 0) {
      return 0;
    }
    if(unformattedNumberOfTokens < 10) {
      return parseFloat("0.0000" + unformattedNumberOfTokens);
    }
  if(unformattedNumberOfTokens < 100) {
    return parseFloat("0.000" + unformattedNumberOfTokens);
  }
  if(unformattedNumberOfTokens < 1000) {
    return parseFloat("0.00" + unformattedNumberOfTokens);
  }
  if(unformattedNumberOfTokens < 10000) {
    return parseFloat("0.0" + unformattedNumberOfTokens);
  }
  if(unformattedNumberOfTokens < 100000) {
    return parseFloat("0." + unformattedNumberOfTokens);
  }
  return unformattedNumberOfTokens.toString().slice(0, -5) + "." + unformattedNumberOfTokens.toString().slice(-5);
};

export async function initContract() {

  const near = await connect(nearConfig);

  // Initializing Wallet based Account. It can work with NEAR testnet wallet that
  // is hosted at https://wallet.testnet.near.org
  walletConnection = new WalletConnection(near);

  // Getting the Account ID. If still unauthorized, it's just empty string
  const accountId = walletConnection.getAccountId();

  // Initializing our contract APIs by contract name and configuration
  const contract = await new Contract(
    walletConnection.account(),
    nearConfig.contractName,
    {
      viewMethods: ["get_user"],
      changeMethods: ["claim"],
    }
  );

  let claimableTokens = 0;
  if(accountId) {
    try {
      const response = await contract.get_user({
        account_id: accountId,
      });
      claimableTokens = formatTokensToFiveDecimalPlaces(response.claim_balance);
    } catch (err) {
      if(err.message.includes('is not registered')) {
        // Do nothing - claimable tokens is zero, as they are not registered
      } else {
        // Do something to handle this gracefully
      }
    }
  }

  return {
    walletConnection: walletConnection,
    accountId: accountId,
    claimableTokens: claimableTokens,
    contract: contract,
    nearConfig: nearConfig,
  };
}

export function logout() {
  walletConnection.signOut();
  window.location.replace(window.location.origin + window.location.pathname);
}

export function login() {
  // Allow the current app to make calls to the specified contract on the
  // user's behalf.
  // This works by creating a new access key for the user's account and storing
  // the private key in localStorage.
  walletConnection.requestSignIn(nearConfig.contractName);
}
